import {useState, useEffect} from 'react'
import {addLabelToArray} from '../helpers';
import {useApi} from '../context';

export default function useChannels() {
    let api = useApi();

    const [isLoading, setIsLoading] = useState(true);
    const [channels, setChannel] = useState([]);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        
        const fetchData = async() => {
            setIsLoading(true)
            let results = null;

                results = await api.getChannels();
          
            if(results.statusCode === 200) {
                let {data, message} = results;
                    setChannel(addLabelToArray(data))
              
            } 
            else {
                let {error} = results;
                setHasError(error);
            }
            // setIsLoading(false);
        }

        fetchData();
        return () => {
            return [channels, isLoading, hasError ]
        }
    }, [])

    return {channels, isLoading, hasError}
}
